import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 25 2019
 * @author Vojtěch Smolař
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import moment from 'moment';
import { action, computed } from 'mobx';
import { List } from 'immutable';
import { ColumnGenerator, CircleStateRenderer, RendererNames } from '../../../components/tables/AgGrid';
import { DPTransferStatus } from '../../../shared/dataPump/enums/DPTransferStatus';
import { LoadingState } from '../../../shared/api/LoadingState';
import { PageStore } from '../../../shared/stores/PageStore';
import { TransferStatusImportLayer } from '../../../shared/transportLayers/system-admin/TransferStatusImportLayer';
import { getDateTimeFormat } from '../../../shared/date/getDateFormat';
import { humanizeDuration } from '../../../utils/humanizeDuration';
import { QuerryFormFilter, QuerryFormStore } from '../../../shared/stores/system-admin/QuerryFormStore';
import { DateParser, StructPropBuilder } from '@logio/common-be-fe';

var ImportsPageStore =
/*#__PURE__*/
function (_PageStore) {
  _inherits(ImportsPageStore, _PageStore);

  function ImportsPageStore(limit, offset, history) {
    var _this;

    _classCallCheck(this, ImportsPageStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImportsPageStore).call(this));
    _this.limit = limit;
    _this.offset = offset;
    _this.history = history;
    /** Get dependent layers */

    _this.transferStatusImportLayer = new TransferStatusImportLayer();
    /** Get dependent filter form store */

    _this.filterStore = new QuerryFormStore();
    /** Get dependent structure builder */

    _this.builder = new StructPropBuilder('SystemAdminDPImport');
    /** Column generator */

    _this.treeColumnGenerator = new ColumnGenerator({
      type: _this.builder.str('type'),
      status: _this.builder.str('status'),
      created: _this.builder.date('created', DateParser.ISO_PATTERN),
      started: _this.builder.date('started', DateParser.ISO_PATTERN),
      finished: _this.builder.date('finished', DateParser.ISO_PATTERN),
      duration: _this.builder.str('duration'),
      transferMode: _this.builder.str('transferMode')
    });
    return _this;
  }
  /**
   * Getter for auto group column definition
   * @returns ColumnDefinition
   */


  _createClass(ImportsPageStore, [{
    key: "getDataPath",

    /**
     * Get path for tree node group
     * @param data
     */
    value: function getDataPath(data) {
      return data.path;
    }
    /**
     * Getter for generated tree row data
     * @returns StringMapping<any>
     */

  }, {
    key: "buildTreeRowData",

    /**
     * Builds tree node row data
     * @param logs
     */
    value: function buildTreeRowData(logs) {
      var rowData = [];
      this.buildTreeNode(logs, rowData);
      return rowData;
    }
    /**
     * Builder for root tree node
     * @param logs
     * @param rowData
     */

  }, {
    key: "buildTreeNode",
    value: function buildTreeNode(logs, rowData) {
      var _this2 = this;

      logs.forEach(function (log) {
        var created = moment(log.created);
        var pathId = "".concat(created.clone().format(getDateTimeFormat()), " : ").concat(log.id);
        var rootPath = List.of(pathId);
        rowData.push(Object.assign({
          path: rootPath.toArray()
        }, _this2.treeColumnGenerator.getColumnData({
          type: log.type,
          status: log.status,
          created: created,
          started: log.started,
          finished: log.finished,
          duration: humanizeDuration(log.started, log.finished)
        })));
        var dataTypes = List(log.dataTypes);

        if (dataTypes.size > 0) {
          _this2.buildDataTypeTreeNodes(rootPath, dataTypes, rowData);
        }
      });
    }
    /**
     * Tree node builder for data type items
     * @param path
     * @param dataTypes
     * @param rowData
     */

  }, {
    key: "buildDataTypeTreeNodes",
    value: function buildDataTypeTreeNodes(path, dataTypes, rowData) {
      var _this3 = this;

      dataTypes.forEach(function (dataType) {
        var extendedPath = path.push(dataType.name);
        rowData.push(Object.assign({
          path: extendedPath.toArray()
        }, _this3.treeColumnGenerator.getColumnData({
          type: null,
          status: dataType.status,
          created: null,
          started: dataType.started,
          finished: dataType.finished,
          duration: dataType.status === 'SUCCESS' ? humanizeDuration(dataType.started, dataType.finished) : '---',
          transferMode: dataType.transferMode
        })));
        var processors = List(dataType.processors);

        if (processors.size > 0) {
          _this3.buildProcessorTreeNodes(extendedPath, processors, rowData);
        }
      });
    }
    /**
     * Tree node builder for processor items
     * @param path
     * @param processors
     * @param rowData
     */

  }, {
    key: "buildProcessorTreeNodes",
    value: function buildProcessorTreeNodes(path, processors, rowData) {
      var _this4 = this;

      processors.forEach(function (processor) {
        var extendedPath = path.push(processor.name);
        rowData.push(Object.assign({
          path: extendedPath.toArray()
        }, _this4.treeColumnGenerator.getColumnData({
          type: null,
          status: processor.status,
          created: null,
          started: processor.started,
          finished: processor.finished
        })));
      });
    }
    /**
     * Handler for AgGrid pos actions when grid is ready to show some data
     * @param params
     */

  }, {
    key: "onGridReady",
    value: function onGridReady(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
                _context.next = 4;
                return this.loadImportTransferLog(this.filterStore.initialValues.limit, this.filterStore.initialValues.offset);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     *
     * @returns Promise<any>
     */

  }, {
    key: "loadImportTransferLog",
    value: function loadImportTransferLog(limit) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var logs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.gridApi.showLoadingOverlay();
                this.gridApi.setRowData([]);
                _context2.next = 4;
                return this.transferStatusImportLayer.getImportTransferLog(limit, offset);

              case 4:
                logs = _context2.sent;
                this.gridApi.updateRowData({
                  add: this.buildTreeRowData(logs)
                });
                this.gridApi.hideOverlay();
                this.gridApi.sizeColumnsToFit();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Filter form submit handler
     * @param filterValues
     */

  }, {
    key: "onFilterFormSubmit",
    value: function onFilterFormSubmit(filterValues) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.loadImportTransferLog(filterValues.limit, filterValues.offset);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Fetches dependent data before page loads
     */

  }, {
    key: "load",
    value: function load() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setLoadingState(LoadingState.Pending);

                try {
                  // TODO: You can load something here
                  this.setLoadingState(LoadingState.Success);
                } catch (error) {
                  this.setLoadingState(LoadingState.Error); // this.messages.setError(error);
                }

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "autoGroupColumnDef",
    get: function get() {
      return {
        width: 400,
        suppressMovable: true,
        cellRendererParams: {
          suppressCount: true,
          innerRenderer: RendererNames.BoldRenderer
        }
      };
    }
    /**
     * Getter for generated tree column definitions
     * @returns ColumnDefinition[]
     */

  }, {
    key: "treeColumnDefs",
    get: function get() {
      var formatter = {
        DateTime: function DateTime(_ref) {
          var value = _ref.value;
          return value ? moment(value).format(getDateTimeFormat()) : null;
        },
        Status: function Status(_ref2) {
          var value = _ref2.value;
          return value ? DPTransferStatus[value] : null;
        }
      };
      return _toConsumableArray(this.treeColumnGenerator.getColumnDefinitions([{
        field: 'type'
      }, {
        field: 'status',
        valueFormatter: formatter.Status,
        cellRendererFramework: CircleStateRenderer,
        cellRendererParams: {
          translate: false
        }
      }, {
        field: 'created',
        valueFormatter: formatter.DateTime
      }, {
        field: 'started',
        valueFormatter: formatter.DateTime
      }, {
        field: 'finished',
        valueFormatter: formatter.DateTime
      }, {
        field: 'duration'
      }, {
        field: 'transferMode'
      }]));
    }
  }, {
    key: "treeRowData",
    get: function get() {
      return [];
    }
  }]);

  return ImportsPageStore;
}(PageStore);

export { ImportsPageStore as default };

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], ImportsPageStore.prototype, "autoGroupColumnDef", null);

__decorate([computed, __metadata("design:type", Array), __metadata("design:paramtypes", [])], ImportsPageStore.prototype, "treeColumnDefs", null);

__decorate([computed, __metadata("design:type", Array), __metadata("design:paramtypes", [])], ImportsPageStore.prototype, "treeRowData", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Array)], ImportsPageStore.prototype, "buildTreeRowData", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", void 0)], ImportsPageStore.prototype, "buildTreeNode", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object, Array]), __metadata("design:returntype", void 0)], ImportsPageStore.prototype, "buildDataTypeTreeNodes", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object, Array]), __metadata("design:returntype", void 0)], ImportsPageStore.prototype, "buildProcessorTreeNodes", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ImportsPageStore.prototype, "onGridReady", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", Promise)], ImportsPageStore.prototype, "loadImportTransferLog", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [QuerryFormFilter]), __metadata("design:returntype", Promise)], ImportsPageStore.prototype, "onFilterFormSubmit", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ImportsPageStore.prototype, "load", null);